module.exports = __webpack_public_path__ + "img/car_rear_right_outline.147827a5.svg";